import { TriangleAlert } from "lucide-react";
import { CreateTaskDialog } from "../components/create-task-dialog";
import { ActivityChart } from "../components/overview/activity-chart";
import { ActivityFeed } from "../components/overview/activity-feed";
import { AttentionList } from "../components/overview/attention-list";
import { KpiCards } from "../components/overview/kpi-cards";
import { MergeQueueCard } from "../components/overview/merge-queue-card";
import { ProductionBoard } from "../components/overview/production-board";
import { EmptyState, PageHeader, PageSkeleton } from "../components/page";
import { useFactory } from "../store";

export function OverviewPage() {
  const { layout, state, loading, error, ticker, realtime } = useFactory();
  if (error) {
    return <EmptyState icon={TriangleAlert} title="Could not load the factory" description={error.message} />;
  }
  if (loading || !layout || !state) return <PageSkeleton />;

  return (
    <>
      <PageHeader
        title="Overview"
        description={`${layout.name} · ${state.kpis.inProduction} work orders on the line`}
        actions={<CreateTaskDialog />}
      />
      <KpiCards layout={layout} state={state} />
      <ProductionBoard layout={layout} state={state} />
      <div className="grid gap-6 @5xl/main:grid-cols-3">
        <div className="flex min-w-0 flex-col gap-6 @5xl/main:col-span-2">
          <AttentionList state={state} />
          <ActivityChart runs={state.runs} />
        </div>
        <div className="flex min-w-0 flex-col gap-6">
          <ActivityFeed items={ticker} live={realtime === "connected"} />
          <MergeQueueCard state={state} />
        </div>
      </div>
    </>
  );
}
